import { Platform } from 'react-native';

type EventProperties = Record<string, unknown>;

type AmplitudeModule = {
  init?: (apiKey: string, userId?: string, options?: Record<string, unknown>) => unknown;
  track?: (eventType: string, eventProperties?: EventProperties) => unknown;
  identify?: (...args: unknown[]) => unknown;
  setUserId?: (userId?: string) => unknown;
};

let amplitudeModule: AmplitudeModule | null = null;

if (Platform.OS !== 'web') {
  try {
    amplitudeModule = require('@amplitude/analytics-react-native') as AmplitudeModule;
  } catch (error) {
    if (__DEV__) {
      console.warn('[amplitude] native module unavailable', error);
    }
  }
}

export function amplitudeInit(apiKey: string, options?: Record<string, unknown>) {
  // The SDK accepts options as its third argument. Keep advertising IDs out
  // of events while retaining ordinary usage analytics on native platforms.
  return amplitudeModule?.init?.(apiKey, undefined, {
    ...options,
    trackingOptions: {
      ...((options?.trackingOptions as Record<string, unknown>) || {}),
      adid: false,
    },
  });
}

export function amplitudeTrack(eventType: string, eventProperties?: EventProperties) {
  return amplitudeModule?.track?.(eventType, eventProperties);
}

export function amplitudeIdentify(...args: unknown[]) {
  return amplitudeModule?.identify?.(...args);
}

export function amplitudeSetUserId(userId?: string) {
  return amplitudeModule?.setUserId?.(userId);
}

const amplitude = {
  init: amplitudeInit,
  track: amplitudeTrack,
  identify: amplitudeIdentify,
  setUserId: amplitudeSetUserId,
};

export default amplitude;
